function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d2d3d4",
  d: "M10.44 3.91h3v20.93h-3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d2d3d4",
  d: "M9.38 11.87h5v5h-5zM0 0h4v10H0zM19 0h4v10h-4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d2d3d4",
  d: "M0 0h4v10H0zM19 0h4v10h-4zM9.38 3h5v4h-5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d2d3d4",
  d: "M3.5 4h18.63v2H3.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  d: "M0 19h4v10H0zM19 19h4v10h-4zM9.38 22h5v4h-5z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  d: "M1.2 23h20.96v2H1.2z"
});

var SvgSingleRwd = function SvgSingleRwd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "single_rwd_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 23 29"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default SvgSingleRwd;